import PricesList from 'components/Lists/ListView/PricesList';
import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { IModifierPositionItem } from 'types';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IModifierPositionItem;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

const Item: React.FC<IItem> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const nameRowClasses = classNames(style.name, style.row);
	const modifierNameClasses = classNames(style.modifierName);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);
	const isDisabledRowClasses = classNames(style.isDisabled, style.row, style.list);
	const priceRowClasses = classNames(style.price, style.row, style.list);

	const restaurants = data.restaurants.map((el) => ({
		...el,
		restaurantName: el.name,
	}));

	const isDisabledRestaurants = restaurants.filter((el) => el.isDisabled);

	return (
		<div className={containerClasses}>
			<div className={nameRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<Text className={modifierNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<div className={restaurantRowClasses}>
				<RestaurantsList restaurants={restaurants} />
			</div>
			<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
			<div className={isDisabledRowClasses}>
				<RestaurantsList restaurants={isDisabledRestaurants} />
			</div>
			<div className={priceRowClasses}>
				<PricesList restaurants={restaurants} />
			</div>
		</div>
	);
};

export default Item;
